import { render, staticRenderFns } from "./ModalCancelamentoLaudo.vue?vue&type=template&id=62979260&lang=pug"
import script from "./ModalCancelamentoLaudo.vue?vue&type=script&lang=js"
export * from "./ModalCancelamentoLaudo.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelamentoLaudo.vue?vue&type=style&index=0&id=62979260&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports